import React from 'react';
import Navbar from '../components/Navbar';
import SeasonalBanner from '../components/SeasonalBanner';
import History from '../components/History';
import Footer from '../components/Footer';
import { useLang } from '../LanguageContext';
import { useTheme } from '../ThemeContext';

const Inner = () => {
  const { t } = useLang();
  const theme = useTheme();
  return (
    <div className="min-h-screen" style={{ background: '#f6ecd9' }}>
      <SeasonalBanner />
      <Navbar />
      <section
        className="relative pb-20 overflow-hidden"
        style={{ background: theme.primary, paddingTop: 'calc(var(--banner-h, 0px) + 160px)' }}
      >
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage: 'radial-gradient(#d4a94c 1px, transparent 1px)',
            backgroundSize: '28px 28px'
          }}
        />
        <div className="relative max-w-6xl mx-auto px-6">
          <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6 fade-up">
            {t.history.eyebrow}
          </p>
          <h1 className="font-serif text-5xl md:text-7xl text-[#f6ecd9] leading-[1.05] fade-up fade-up-delay-1">
            {t.history.t1} <em className="italic font-light text-[#d4a94c]">{t.history.t2}</em>
          </h1>
        </div>
      </section>
      <History hideHeading />
      <Footer />
    </div>
  );
};

const HistoryPage = () => <Inner />;

export default HistoryPage;
